import { Directive, ElementRef, HostListener, inject, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[appUppercase]',
})
export class UppercaseDirective implements OnInit {
  @Input() public appUppercase!: boolean;
  private elementRef = inject(ElementRef);

  public ngOnInit(): void {
    if (this.appUppercase) {
      this.elementRef.nativeElement.style.textTransform = 'uppercase';
    }
  }

  @HostListener('keyup', ['$event']) public onInput(event: KeyboardEvent): void {
    if (!this.appUppercase) return;
    const input = event.target as HTMLInputElement;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    input.value = input.value.toUpperCase();
    if (start !== null && end !== null) {
      input.setSelectionRange(start, end);
    }

    input.dispatchEvent(new Event('input'));
  }
}
